import React, { useEffect, useState } from 'react';
import { useLoadingBar } from './useLoadingBar';
import { Track, Fill } from './LoadingBar.styled';

const LoadingBar = () => {
    const { progress, isActive, isComplete } = useLoadingBar();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isActive && !isComplete) {
            setVisible(true);

            return;
        }

        if (isComplete) {
            // Keep visible briefly at 100% before fading out
            const timer = setTimeout(() => {
                setVisible(false);
            }, 300);

            return () => clearTimeout(timer);
        }

        setVisible(false);
    }, [isActive, isComplete]);

    if (!isActive) {
        return null;
    }

    return (
        <Track $visible={visible}>
            <Fill $progress={progress} />
        </Track>
    );
};

export default LoadingBar;
